/*
 * SPDX-FileCopyrightText: 2026 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { useApplicationState } from '../../../hooks/common/use-application-state'
import { useBooleanState } from '../../../hooks/common/use-boolean-state'
import { cypressId } from '../../../utils/cypress-attribute'
import { UiIcon } from '../../common/icons/ui-icon'
import { SettingsModal } from '../../global-dialogs/settings-dialog/settings-modal'
import { SignOutDropdownButton } from './sign-out-dropdown-button'
import Link from 'next/link'
import React, { Fragment } from 'react'
import { Dropdown } from 'react-bootstrap'
import { Gear as IconGear, Person as IconPerson, InfoCircle as IconInfoCircle } from 'react-bootstrap-icons'
import { Trans, useTranslation } from 'react-i18next'
import { UserAvatar } from '../../common/user-avatar/user-avatar'

/**
 * Renders a dropdown menu with user-relevant actions.
 */
export const UserDropdown: React.FC = () => {
  useTranslation()
  const user = useApplicationState((state) => state.user)
  const [settingsVisible, showSettings, hideSettings] = useBooleanState(false)

  if (!user) {
    return null
  }

  return (
    <Fragment>
      <Dropdown align={'end'}>
        <Dropdown.Toggle
          {...cypressId('user-dropdown')}
          size='sm'
          variant={'app-bar'}
          className={'d-flex align-items-center'}>
          <UserAvatar user={user} />
        </Dropdown.Toggle>

        <Dropdown.Menu className='text-start'>
          <Link href={'/about'} passHref={true} legacyBehavior={true}>
            <Dropdown.Item dir='auto' {...cypressId('user-dropdown-profile-button')}>
              <UiIcon icon={IconInfoCircle} className='mx-2' />
              <Trans i18nKey='about.title' />
            </Dropdown.Item>
          </Link>
          <Dropdown.Divider />
          <Dropdown.Item
            as={'button'}
            dir='auto'
            onClick={showSettings}
            {...cypressId('user-dropdown-display-settings-button')}>
            <UiIcon icon={IconGear} className='mx-2' />
            <Trans i18nKey='userDropdown.displaySettings' />
          </Dropdown.Item>
          <Link href={'/profile'} passHref={true} legacyBehavior={true}>
            <Dropdown.Item dir='auto' {...cypressId('user-dropdown-profile-button')}>
              <UiIcon icon={IconPerson} className='mx-2' />
              <Trans i18nKey='profile.userProfile' />
            </Dropdown.Item>
          </Link>
          <SignOutDropdownButton />
        </Dropdown.Menu>
      </Dropdown>
      <SettingsModal show={settingsVisible} onHide={hideSettings} />
    </Fragment>
  )
}
